import React from "react";
import { Routes, Route } from "react-router-dom";
import ListLeads from "../Components/Lead Management/listLeads";
const LeadRoutes = () => {
  return (
    <Routes>
      <Route path="/lead_management" element={<ListLeads></ListLeads>}></Route>
    </Routes>
  );
};

export default LeadRoutes;
